/* Sisters Moto: moved out of snippets/sm-ymm-plus.liquid so it is cached instead of repeated in every page. */
(function () {
  'use strict';
  if (window.SmYmmPlus) return;
  var C = window.SmYmmConfig || {};

  /* ---------- helpers ---------- */

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function lsGet(key, fallback) {
    try { var v = JSON.parse(localStorage.getItem(key)); return v == null ? fallback : v; } catch (e) { return fallback; }
  }
  function lsSet(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }
  function ssGet(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function ssSet(key, value) { try { sessionStorage.setItem(key, value); } catch (e) {} }
  function ssDel(key) { try { sessionStorage.removeItem(key); } catch (e) {} }

  // The customer's active MotoFit bike, as display labels
  function vehicle() {
    var v = window.motofitSelectedVehicle;
    if (!v || !v.year || !v.make || !v.model) return null;
    var out = { year: String(v.year).trim(), make: String(v.make).trim(), model: String(v.model).trim() };
    out.label = out.year + ' ' + out.make + ' ' + out.model;
    return out;
  }

  // Calls back with the vehicle once MotoFit has loaded it, or null after maxMs (default 10s)
  function whenVehicle(cb, maxMs) {
    var v = vehicle();
    if (v) return cb(v);
    var tries = 0;
    var limit = Math.ceil((maxMs || 10000) / 250);
    var t = setInterval(function () {
      v = vehicle();
      if (v || ++tries > limit) { clearInterval(t); cb(v); }
    }, 250);
  }

  function track(name, data) {
    if (!C.analytics) return;
    var payload = data || {};
    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: name };
      Object.keys(payload).forEach(function (k) { dl[k] = payload[k]; });
      window.dataLayer.push(dl);
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
  }

  var toastEl = document.querySelector('[data-sm-toast]');
  var toastTimer = null;
  function toast(text) {
    if (!toastEl) return;
    toastEl.textContent = text;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 5000);
  }

  function telHref(phone) { return 'tel:' + String(phone || '').replace(/[^\d+]/g, ''); }

  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); }
    else d.setAttribute('open', '');
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
  }
  // Click on the dimmed area outside the panel closes a dialog
  document.querySelectorAll('.sm-yp-dialog').forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-sm-dialog-close]')) closeDialog(d);
    });
  });

  /* ---------- 1. hide empty years and makes ---------- */

  var Prune = (function () {
    if (!C.hideEmpty && !(C.oldestYear > 0)) return null;
    var STORE_KEY = 'smoto:ymm-avail:v1';
    var TTL_OK = 7 * 864e5;       // a year/make with bikes stays trusted for a week
    var TTL_EMPTY = 12 * 36e5;    // an empty one is re-checked after 12 hours
    var MAX_PARALLEL = 4;
    var store = lsGet(STORE_KEY, null);
    if (!store || !store.y || !store.m) store = { y: {}, m: {} };
    var pending = {};
    var queue = [];
    var running = 0;
    var active = false;           // start asking MotoFit only once the selector is in use
    var scopes = [];
    var raf = 0;

    function known(bucket, key) {
      var e = store[bucket][key];
      if (!e) return undefined;
      return (Date.now() - e.t) < (e.ok ? TTL_OK : TTL_EMPTY) ? e.ok : undefined;
    }
    function remember(bucket, key, ok) {
      store[bucket][key] = { ok: ok, t: Date.now() };
      lsSet(STORE_KEY, store);
    }

    // true = has entries, false = definitely empty, null = can't tell (keep the option)
    function hasEntries(json, listKey) {
      if (Array.isArray(json)) return json.length > 0;
      if (!json || typeof json !== 'object') return null;
      var keys = [listKey, 'data', 'results'];
      for (var i = 0; i < keys.length; i++) {
        var list = json[keys[i]];
        if (Array.isArray(list)) return list.length > 0;
        if (list && typeof list === 'object') return Object.keys(list).length > 0;
      }
      return null;
    }

    function fill(tpl, values) {
      return String(tpl).replace(/\{(\w+)\}/g, function (_, k) { return encodeURIComponent(values[k] == null ? '' : values[k]); });
    }

    // MotoFit's own browser cache from an earlier pick, if it has one
    function motofitCache(year) {
      var c = lsGet('fetchMakes_' + year, null);
      if (c && c.data && Array.isArray(c.data.makes) && Date.now() - c.timestamp < 10 * 60000) return c.data.makes.length > 0;
      return undefined;
    }

    function check(bucket, key, url, listKey) {
      if (known(bucket, key) !== undefined || pending[bucket + key]) return;
      if (bucket === 'y') {
        var cached = motofitCache(key);
        if (cached !== undefined) { remember('y', key, cached); return schedule(); }
      }
      pending[bucket + key] = true;
      queue.push(function () {
        return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (json) {
            var result = json == null ? null : hasEntries(json, listKey);
            if (result !== null) remember(bucket, key, result);
          })
          .catch(function () {})
          .then(function () { delete pending[bucket + key]; schedule(); });
      });
      pump();
    }
    function pump() {
      while (running < MAX_PARALLEL && queue.length) {
        running++;
        queue.shift()().then(function () { running--; pump(); });
      }
    }

    function isYearSelect(s) {
      var opts = Array.prototype.filter.call(s.options, function (o) { return o.value.trim() !== ''; });
      if (!opts.length) return false;
      var years = opts.filter(function (o) { return /^\d{4}$/.test(o.textContent.trim()); });
      return years.length / opts.length > 0.8;
    }

    function selectsIn(scope) {
      var selects = Array.prototype.slice.call(scope.querySelectorAll('select'));
      var yearSel = selects.filter(isYearSelect)[0];
      if (!yearSel) return null;
      var rest = selects.filter(function (s) { return s !== yearSel && !isYearSelect(s); });
      var makeSel = rest.filter(function (s) {
        return /make/i.test((s.name || '') + ' ' + (s.id || '') + ' ' + (s.className || '') + ' ' + (s.getAttribute('aria-label') || ''));
      })[0] || rest[0] || null;
      return { year: yearSel, make: makeSel };
    }

    function prune() {
      raf = 0;
      scopes.forEach(function (scope) {
        var s = selectsIn(scope);
        if (!s) return;

        // Years: older than the "Hide years older than" setting go without asking MotoFit.
        // MotoFit's years are continuous back to that year, so only the newest model years
        // (this year and next, which fill in as new bikes are added) are checked: 2 requests, not ~90.
        var newestToCheck = new Date().getFullYear();
        var yearOpts = Array.prototype.slice.call(s.year.options)
          .filter(function (o) { return /^\d{4}$/.test(o.textContent.trim()); })
          .sort(function (a, b) { return +b.textContent.trim() - +a.textContent.trim(); });
        yearOpts.forEach(function (o) {
          var num = +o.textContent.trim();
          var key = o.value.trim();
          if (o.selected) return;
          if (C.oldestYear > 0 && num < C.oldestYear) { o.remove(); return; }
          if (!C.hideEmpty || num < newestToCheck) return;
          var ok = known('y', key);
          if (ok === false) o.remove();
          else if (ok === undefined && active) check('y', key, fill(C.makesUrl, { year: key }), 'makes');
        });

        // Makes for the chosen year (once the shopper is using the form)
        var year = s.year.value.trim();
        if (!C.hideEmpty || !active || !s.make || !year) return;
        Array.prototype.slice.call(s.make.options).forEach(function (o) {
          var make = o.value.trim();
          if (!make || o.selected) return;
          var key = year + '|' + make;
          var ok = known('m', key);
          if (ok === false) o.remove();
          else if (ok === undefined) check('m', key, fill(C.modelsUrl, { year: year, make: make }), 'models');
        });
      });
    }

    function schedule() {
      if (raf) return;
      raf = window.requestAnimationFrame ? window.requestAnimationFrame(prune) : setTimeout(prune, 16);
    }

    function start() {
      if (active) return;
      active = true;
      schedule();
    }

    function watch(scope) {
      if (scopes.indexOf(scope) > -1) return;
      scopes.push(scope);
      new MutationObserver(schedule).observe(scope, { childList: true, subtree: true });
      scope.addEventListener('change', schedule, true);
      // Ask MotoFit only when the shopper reaches for the form, not when it scrolls into view
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
        scope.addEventListener(ev, start, { passive: true, once: true });
      });
      schedule();
    }

    function init() {
      document.querySelectorAll('#ymmInlineWrapper, [data-sm-ymm-prune]').forEach(watch);
    }
    init();
    // MotoFit mounts late on some pages
    window.addEventListener('load', init);
    return { refresh: schedule, start: start };
  })();

  /* ---------- 2. parts desk request form ---------- */

  var pdDialog = document.getElementById('sm-pd-dialog');
  var lastFitment = null; // { state, vehicle } from the product page fitment check

  function openPartsDesk(opts) {
    if (!pdDialog) {
      if (C.phone) window.location.href = telHref(C.phone);
      return;
    }
    opts = opts || {};
    var bikeEl = pdDialog.querySelector('[data-sm-pd-bike]');
    var bodyEl = pdDialog.querySelector('[data-sm-pd-body]');
    var pageEl = pdDialog.querySelector('[data-sm-pd-page]');
    var v = vehicle();
    var bike = opts.bike || (lastFitment && lastFitment.vehicle) || (v && v.label) || '';
    if (bikeEl && !bikeEl.value) bikeEl.value = bike;
    if (bodyEl && !bodyEl.value && opts.part) bodyEl.value = opts.part;
    if (pageEl) pageEl.value = window.location.href;
    pdDialog.setAttribute('data-source', opts.source || 'other');
    openDialog(pdDialog);
    var firstEmpty = Array.prototype.filter.call(pdDialog.querySelectorAll('input[required], textarea[required]'), function (el) { return !el.value; })[0];
    setTimeout(function () { (firstEmpty || bodyEl || pdDialog).focus(); }, 30);
    track('sm_parts_desk_open', { source: opts.source || 'other', vehicle: bike });
  }

  if (pdDialog) {
    var pdForm = pdDialog.querySelector('form');
    if (pdForm) {
      pdForm.addEventListener('submit', function () {
        ssSet('smoto:pd-sent', pdDialog.getAttribute('data-source') || 'other');
      });
    }
    // After the form posts, Shopify reloads the page
    var sentFrom = ssGet('smoto:pd-sent');
    if (sentFrom) {
      ssDel('smoto:pd-sent');
      var posted = pdDialog.querySelector('[data-sm-pd-posted]') || /[?&]contact_posted=true/.test(window.location.search);
      if (pdDialog.querySelector('[data-sm-pd-errors]')) {
        openDialog(pdDialog);
      } else if (posted) {
        toast('Request sent. Our parts desk will reply by email.');
        track('sm_parts_desk_request', { source: sentFrom });
      }
    }
  }

  function productPart() {
    if (!C.product) return '';
    return C.product.title + '\n' + window.location.origin + C.product.url + '\n\n';
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sm-parts-desk]');
    if (!t) return;
    e.preventDefault();
    openPartsDesk({ source: t.getAttribute('data-sm-source') || 'other', part: t.getAttribute('data-sm-part') || productPart() });
  });

  /* ---------- 3. product page: fitment status and the not listed check ---------- */

  var sentStatus = {};
  document.addEventListener('smoto:fitment:status', function (e) {
    lastFitment = e.detail || null;
    if (!lastFitment || lastFitment.state === 'no-vehicle') return;
    var key = lastFitment.state + '|' + lastFitment.vehicle;
    if (sentStatus[key]) return;
    sentStatus[key] = true;
    track('sm_fitment_status', {
      state: lastFitment.state,
      vehicle: lastFitment.vehicle,
      product_id: C.product ? C.product.id : null,
      product_title: C.product ? C.product.title : null
    });
  });

  var confirmDialog = document.getElementById('sm-fit-confirm');
  if (confirmDialog && C.product) {
    var BUY_BUTTONS = '.simple-add-to-cart-btn, .simple-buy-now-btn, .simple-sticky-cart-btn';
    var OK_KEY = 'smoto:fit-confirmed';
    var pendingButton = null;

    var confirmedKey = function () { return C.product.id + '|' + (lastFitment ? lastFitment.vehicle : ''); };
    var isConfirmed = function () {
      try { return (JSON.parse(ssGet(OK_KEY) || '[]')).indexOf(confirmedKey()) > -1; } catch (err) { return false; }
    };
    var setConfirmed = function () {
      var list = [];
      try { list = JSON.parse(ssGet(OK_KEY) || '[]'); } catch (err) {}
      list.push(confirmedKey());
      ssSet(OK_KEY, JSON.stringify(list.slice(-30)));
    };

    document.addEventListener('click', function (e) {
      var btn = e.target.closest(BUY_BUTTONS);
      if (!btn || btn.disabled) return;
      if (!lastFitment || lastFitment.state !== 'not-listed' || isConfirmed()) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      pendingButton = btn;
      var isBuyNow = btn.classList.contains('simple-buy-now-btn');
      confirmDialog.querySelector('[data-sm-confirm-title]').textContent =
        'Your ' + lastFitment.vehicle + ' isn\'t on this part\'s fitment list';
      confirmDialog.querySelector('[data-sm-confirm="add"]').textContent = isBuyNow ? 'Buy now anyway' : 'Add to cart anyway';
      openDialog(confirmDialog);
      setTimeout(function () { confirmDialog.querySelector('[data-sm-confirm="add"]').focus(); }, 30);
    }, true);

    confirmDialog.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sm-confirm]');
      if (!b) return;
      var choice = b.getAttribute('data-sm-confirm');
      closeDialog(confirmDialog);
      track('sm_fitment_not_listed_choice', { choice: choice, vehicle: lastFitment ? lastFitment.vehicle : '', product_id: C.product.id });
      if (choice === 'add' && pendingButton) {
        setConfirmed();
        var btn = pendingButton;
        pendingButton = null;
        btn.click();
      } else if (choice === 'ask') {
        pendingButton = null;
        openPartsDesk({ source: 'product_not_listed', part: productPart() });
      } else {
        pendingButton = null;
      }
    });
  }

  /* ---------- 4. MotoFit results page (and the /search word-swap note) ---------- */

  (function () {
    var path = window.location.pathname;
    var onResults = /^\/apps\/get-api-data/.test(path) || /^\/pages\/manifest-ymm/.test(path);
    var onSearch = path === '/search';
    if (!onResults && !onSearch) return;

    var main = document.getElementById('MainContent') || document.body;
    var params = new URLSearchParams(window.location.search);
    var qKey = onResults ? 'motofitSearchQuery' : 'q';
    var query = (params.get(qKey) || '').trim();
    var fixedFrom = (params.get('sm_from') || '').trim();

    function withQuery(q, extra) {
      var u = new URL(window.location.href);
      u.searchParams.set(qKey, q);
      u.searchParams.delete('sm_from');
      if (u.searchParams.has('page')) u.searchParams.set('page', '1');
      Object.keys(extra || {}).forEach(function (k) { u.searchParams.set(k, extra[k]); });
      return u.pathname + '?' + u.searchParams.toString();
    }

    // "Showing results for sprocket. Search instead for sproket" after a word swap
    function fixedNoteHtml() {
      if (!fixedFrom || !query) return '';
      return 'Showing results for \u201c' + esc(query) + '\u201d. ' +
        '<a class="sm-yp-bar__link" href="' + esc(withQuery(fixedFrom, { sm_nofix: '1' })) + '" data-sm-empty-action="search_instead">' +
        'Search instead for \u201c' + esc(fixedFrom) + '\u201d</a>';
    }

    if (onSearch) {
      var noteHtml = fixedNoteHtml();
      if (!noteHtml) return;
      var note = document.createElement('p');
      note.className = 'sm-yp-fixnote';
      note.innerHTML = noteHtml;
      var h1 = main.querySelector('h1');
      if (h1) h1.parentNode.insertBefore(note, h1.nextSibling);
      else main.insertBefore(note, main.firstChild);
      return;
    }

    var EMPTY_TEXT = /no products (were )?found|no products match|found for your selected vehicle|nothing here yet/i;
    var currentVehicle = null;
    var strip = null;
    var dym = null;
    var anchor = null;
    var bar = null;

    /* -- the empty card -- */

    function findEmpty() {
      var el = main.querySelector('.nothing-here-yet, .motofit-no-results, .ymm-no-results, [data-motofit-empty]');
      if (el) return el;
      var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (n.parentElement && n.parentElement.closest('.sm-yp-desk, .sm-yp-bar, script, style, noscript')) return NodeFilter.FILTER_SKIP;
          return EMPTY_TEXT.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      var node = walker.nextNode();
      if (!node) return null;
      return node.parentElement.closest('div, section, p') || node.parentElement;
    }

    // Last results MotoFit loaded (captured in snippets/sm-ymm-config.liquid), if it loads them as JSON
    function results() { return window.SmYmmResults || null; }

    function isEmpty() {
      var R = results();
      if (R) return R.total === 0;
      return !!findEmpty();
    }

    // The row holding MotoFit's buttons inside its empty card
    function actionRow(card) {
      var btns = card.querySelectorAll('button, a[href], [role="button"]');
      if (!btns.length) return null;
      var row = btns[0].parentElement;
      while (row && row !== card && Array.prototype.some.call(btns, function (b) { return !row.contains(b); })) {
        row = row.parentElement;
      }
      return row && row !== card ? row : null;
    }

    // MotoFit's empty state already offers Show all / Change vehicle / Clear search.
    // We add only what it lacks: the parts desk and the phone number, inside its card.
    function buildStrip(v) {
      var el = document.createElement('div');
      el.className = 'sm-yp-desk';
      var actions = [];
      if (C.partsDesk) {
        actions.push('<button type="button" class="sm-yp-pill sm-yp-pill--gold" data-sm-parts-desk data-sm-source="no_results"' +
          (query ? ' data-sm-part="' + esc(query) + '"' : '') + '>Request this part</button>');
      }
      if (C.phone) {
        actions.push('<a class="sm-yp-pill" href="' + esc(telHref(C.phone)) + '" data-sm-empty-action="call">Call ' + esc(C.phone) + '</a>');
      }
      if (!actions.length) return null;
      el.innerHTML =
        '<p class="sm-yp-desk__text">Still can\u2019t find it? Our parts desk can look it up and order it in.</p>' +
        '<div class="sm-yp-desk__actions">' + actions.join('') + '</div>';
      track('sm_ymm_no_results', { vehicle: v ? v.label : '', query: query, swapped_from: fixedFrom });
      return el;
    }

    /* -- 1. did you mean -- */

    // Edit distance where swapping two neighbouring letters counts as one typo ("chian" -> "chain")
    function lev(a, b) {
      var d = [], i, j;
      for (i = 0; i <= a.length; i++) { d[i] = [i]; }
      for (j = 0; j <= b.length; j++) { d[0][j] = j; }
      for (i = 1; i <= a.length; i++) {
        for (j = 1; j <= b.length; j++) {
          var cost = a[i - 1] === b[j - 1] ? 0 : 1;
          d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
          if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
      return d[a.length][b.length];
    }

    function wordsFrom(json) {
      var r = (json && json.resources && json.resources.results) || {};
      var text = [];
      (r.queries || []).forEach(function (q) { text.push(q.text); });
      (r.products || []).forEach(function (p) { text.push(p.title, p.product_type, p.vendor); });
      (r.collections || []).forEach(function (c) { text.push(c.title); });
      return text.join(' ').toLowerCase().split(/[^a-z0-9]+/).filter(function (w) { return w.length > 2; });
    }

    function suggestFor(q) {
      var key = q.toLowerCase();
      var cacheKey = 'smoto:dym:' + key;
      var cached = ssGet(cacheKey);
      if (cached !== null) return Promise.resolve(cached || null);
      var words = key.split(/\s+/).filter(Boolean);
      function ask(term) {
        return fetch('/search/suggest.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product,query,collection&resources[limit]=10&resources[options][unavailable_products]=last',
          { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(wordsFrom)
          .catch(function () { return []; });
      }
      // Ask with the full term, and with the first 4 letters of each long word,
      // so a typo late in the word still finds the real product words
      var asks = [ask(q)].concat(words.filter(function (w) { return w.length >= 5; }).map(function (w) { return ask(w.slice(0, 4)); }));
      return Promise.all(asks).then(function (lists) {
        var vocab = {};
        lists.forEach(function (l) { l.forEach(function (w) { vocab[w] = true; }); });
        var fixed = words.map(function (w) {
          if (vocab[w] || w.length < 4 || /\d/.test(w)) return w;
          var limit = w.length <= 5 ? 1 : (w.length <= 8 ? 2 : 3);
          var best = null, bestD = 99;
          Object.keys(vocab).forEach(function (c) {
            if (c[0] !== w[0] || Math.abs(c.length - w.length) > limit) return;
            var d = lev(w, c);
            if (d < bestD) { bestD = d; best = c; }
          });
          return best && bestD <= limit ? best : w;
        }).join(' ');
        var out = fixed !== key ? fixed : '';
        ssSet(cacheKey, out);
        return out || null;
      });
    }

    function addSuggestion(card, row) {
      if (!query) return;
      suggestFor(query).then(function (s) {
        if (!s || dym || !document.body.contains(card)) return;
        dym = document.createElement('p');
        dym.className = 'sm-yp-dym';
        dym.innerHTML = 'Did you mean <a href="' + esc(withQuery(s)) + '" data-sm-dym>' + esc(s) + '</a>?';
        if (row) row.parentNode.insertBefore(dym, row);
        else card.insertBefore(dym, card.firstChild);
        track('sm_ymm_did_you_mean_shown', { query: query, suggestion: s });
      });
    }

    /* -- 3. vehicle filter bar -- */

    function findSidebar() {
      var aside = main.querySelector('.manifest-ymm-filters, aside');
      if (aside && /brand|price|product type/i.test(aside.textContent)) return aside;
      var range = main.querySelector('input[type="range"]');
      if (!range) return null;
      var el = range.parentElement, found = null;
      while (el && el !== main) {
        var txt = el.textContent || '';
        if (/brand/i.test(txt) && /price/i.test(txt) && !el.querySelector('#product-grid, .nothing-here-yet, .sm-yp-desk')) found = el;
        else if (found) break;
        el = el.parentElement;
      }
      return found;
    }

    function buildBar(v) {
      var el = document.createElement('div');
      el.className = 'sm-yp-bar';
      var oem = C.oemFor ? C.oemFor(v) : null;
      var what = query
        ? 'Showing \u201c' + esc(query) + '\u201d parts that fit your <strong>' + esc(v.label) + '</strong>'
        : 'Showing parts that fit your <strong>' + esc(v.label) + '</strong>';
      var links = [];
      if (query) {
        links.push('<a class="sm-yp-bar__link" href="/search?q=' + encodeURIComponent(query) + '" data-sm-empty-action="search_all_products">Search all products instead</a>');
        links.push('<button type="button" class="sm-yp-bar__link" data-sm-clear-search>Clear search</button>');
      }
      links.push('<button type="button" class="sm-yp-bar__link" data-sm-change-bike>Change bike</button>');
      if (oem) links.push('<a class="sm-yp-pill sm-yp-pill--gold" href="' + esc(oem.url) + '" data-sm-oem-link>OEM parts diagrams</a>');
      var fixNote = fixedFrom && query
        ? 'Spelling fixed from \u201c' + esc(fixedFrom) + '\u201d. <a class="sm-yp-bar__link" href="' +
          esc(withQuery(fixedFrom, { sm_nofix: '1' })) + '" data-sm-empty-action="search_instead">Search \u201c' + esc(fixedFrom) + '\u201d instead</a>'
        : '';
      el.innerHTML =
        '<svg class="sm-yp-bar__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<circle cx="5.5" cy="16.5" r="3"></circle><circle cx="18.5" cy="16.5" r="3"></circle><path d="M5.5 16.5l3.5-6h5l2.5 6"></path><path d="M9 10.5L7.5 7.5H5"></path></svg>' +
        '<div class="sm-yp-bar__text"><p class="sm-yp-bar__what">' + what + '</p>' +
          (fixNote ? '<p class="sm-yp-bar__fix">' + fixNote + '</p>' : '') + '</div>' +
        '<div class="sm-yp-bar__links">' + links.join('') + '</div>';
      return el;
    }

    // The column next to the filter sidebar that holds the product grid
    function productsColumn() {
      var sb = findSidebar();
      var layout = sb && sb.parentElement && sb.parentElement !== main ? sb.parentElement : null;
      if (!layout) return null;
      var cols = Array.prototype.filter.call(layout.children, function (c) {
        return c !== sb && c !== bar && c.querySelector('#product-grid, .nothing-here-yet, [class*="product"]');
      });
      return cols[0] || null;
    }

    // Sits at the top of the results column, lined up with the product grid
    function placeBar() {
      if (!bar) return;
      var col = productsColumn();
      if (col) {
        if (bar.parentNode !== col || col.firstElementChild !== bar) col.insertBefore(bar, col.firstChild);
        return;
      }
      if (!document.body.contains(bar)) main.insertBefore(bar, main.firstChild);
    }

    /* -- 4. sidebar: hide when empty, real top price on the slider -- */

    var priceCache = {};

    function baseKey(url) {
      var u = new URL(url, window.location.origin);
      ['min_price', 'max_price', 'page', 'my_sort_by', 'my_sort_order', 'sm_probe'].forEach(function (k) { u.searchParams.delete(k); });
      u.searchParams.sort();
      return u.pathname + '?' + u.searchParams.toString();
    }

    function priceOf(p) {
      if (!p) return null;
      var raw = p.price != null ? p.price : p.min_price;
      var n = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
      return isFinite(n) ? n : null;
    }

    // Highest price in the current results: MotoFit's own price range if it sends one,
    // otherwise one extra request sorted by price, used only if it really comes back sorted
    function topPrice(R) {
      var key = baseKey(R.url);
      if (key in priceCache) return Promise.resolve(priceCache[key]);
      var range = R.filters && R.filters.price_range;
      if (range && isFinite(parseFloat(range.max)) && parseFloat(range.max) > 0) {
        priceCache[key] = parseFloat(range.max);
        return Promise.resolve(priceCache[key]);
      }
      var u = new URL(R.url, window.location.origin);
      ['min_price', 'max_price'].forEach(function (k) { u.searchParams.delete(k); });
      u.searchParams.set('page', '1');
      u.searchParams.set('my_sort_by', 'price');
      u.searchParams.set('my_sort_order', 'desc');
      u.searchParams.set('sm_probe', '1');
      priceCache[key] = null;
      return fetch(u.pathname + u.search, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var p = j && j.products;
          var items = Array.isArray(p) ? p : (p && Array.isArray(p.data) ? p.data : []);
          var prices = items.map(priceOf).filter(function (n) { return n != null; });
          if (!prices.length) return null;
          for (var i = 1; i < prices.length; i++) if (prices[i] > prices[i - 1] + 0.001) return null;
          return prices[0];
        })
        .catch(function () { return null; })
        .then(function (m) { priceCache[key] = m; return m; });
    }

    function applyTopPrice(sb, top) {
      var inputs = sb.querySelectorAll('input[type="range"]');
      if (inputs.length < 2 || !(top > 0)) return;
      var lo = inputs[0], hi = inputs[1];
      var step = parseFloat(hi.step) || 1;
      // round up to a tidy number ($30 -> $50, $389 -> $400, $1,240 -> $1,300), then to the slider's step
      var nice = top <= 100 ? 10 : (top <= 1000 ? 50 : 100);
      var max = Math.ceil(top / nice) * nice;
      max = Math.max(step, Math.ceil(max / step) * step);
      var oldMax = parseFloat(hi.max);
      if (oldMax === max) return;
      var untouched = !(parseFloat(hi.value) < oldMax);
      lo.max = max;
      hi.max = max;
      if (untouched || parseFloat(hi.value) > max) hi.value = max;
      if (parseFloat(lo.value) > max) lo.value = 0;
      var label = '$' + Math.round(parseFloat(hi.value)).toLocaleString('en-US');
      sb.querySelectorAll('.price-display-max').forEach(function (e) { e.textContent = label; });
      var walker = document.createTreeWalker(sb, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        if (/\$\s?[\d,.]+\s*[-\u2013]\s*\$\s?[\d,.]+/.test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(/(\$\s?[\d,.]+\s*[-\u2013]\s*)\$\s?[\d,.]+/, '$1' + label);
        }
      }
      if (untouched) {
        var prog = sb.querySelector('.progress');
        if (prog) prog.style.right = '0%';
      }
    }

    // Fallback when MotoFit's data isn't available: if every result is on this page
    // ("2 of 2 products" and 2 cards shown), read the prices off the cards
    function domTopPrice() {
      var m = (main.textContent || '').match(/(\d[\d,]*)\s+of\s+(\d[\d,]*)\s+products?/i);
      if (!m) return null;
      var shown = +m[1].replace(/,/g, ''), total = +m[2].replace(/,/g, '');
      if (!total || shown < total) return null;
      var grid = main.querySelector('#product-grid') || productsColumn();
      if (!grid) return null;
      var cards = grid.querySelectorAll(':scope > li, :scope > .grid__item, :scope > div');
      if (cards.length && cards.length < total) return null;
      var top = 0;
      var walker = document.createTreeWalker(grid, NodeFilter.SHOW_TEXT, null);
      var n, re = /\$\s?([\d,]+(?:\.\d{1,2})?)/g, hit;
      while ((n = walker.nextNode())) {
        re.lastIndex = 0;
        while ((hit = re.exec(n.nodeValue))) top = Math.max(top, parseFloat(hit[1].replace(/,/g, '')));
      }
      return top > 0 ? top : null;
    }

    function tidySidebar(empty) {
      var sb = findSidebar();
      if (!sb) return;
      sb.classList.toggle('sm-yp-hide', empty);
      main.querySelectorAll('#manifest_ymm_filter_open, .open-filter-wrap').forEach(function (b) { b.classList.toggle('sm-yp-hide', empty); });
      if (empty) return;
      var R = results();
      if (R && R.total > 0) {
        topPrice(R).then(function (top) { applyTopPrice(sb, top || domTopPrice()); });
      } else {
        applyTopPrice(sb, domTopPrice());
      }
    }

    /* -- main loop -- */

    function update() {
      // MotoFit re-renders on filter changes; drop our additions if its empty card is gone
      if (strip && (!anchor || !document.body.contains(anchor) || !document.body.contains(strip))) {
        if (strip.parentNode) strip.remove();
        if (dym && dym.parentNode) dym.remove();
        strip = null; dym = null; anchor = null;
      }
      var empty = isEmpty();
      tidySidebar(empty);
      placeBar();
      if (strip || !empty) return;
      var el = findEmpty();
      if (!el) return;
      anchor = el;
      var row = actionRow(el);
      var s = buildStrip(currentVehicle);
      if (s) {
        strip = s;
        if (row) row.parentNode.insertBefore(s, row.nextSibling);
        else el.appendChild(s);
      }
      addSuggestion(el, row);
    }

    var timer = 0;
    function schedule() { clearTimeout(timer); timer = setTimeout(update, 120); }
    new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    document.addEventListener('smoto:ymm:results', schedule);

    whenVehicle(function (v) {
      currentVehicle = v;
      if (v) bar = buildBar(v);
      update();
    }, 3000);

    // "Clear search" replaces MotoFit's own search strip (hidden in assets/sm-site.css):
    // use MotoFit's clear control so its saved search is cleared too, else drop the term from the URL
    main.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sm-clear-search]')) return;
      e.preventDefault();
      track('sm_ymm_clear_search', { query: query });
      var actions = Array.prototype.slice.call(document.querySelectorAll('.motofit-search-strip__action'));
      var clear = actions.filter(function (b) {
        return /clear|remove|close|reset/i.test((b.getAttribute('aria-label') || '') + ' ' + (b.getAttribute('title') || '') + ' ' + (b.className || ''));
      })[0] || actions[actions.length - 1];
      if (clear) { clear.click(); return; }
      var u = new URL(window.location.href);
      u.searchParams.delete('motofitSearchQuery');
      u.searchParams.delete('sm_from');
      u.searchParams.set('page', '1');
      window.location.href = u.pathname + '?' + u.searchParams.toString();
    });

    main.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sm-empty-action]');
      if (a) track('sm_ymm_no_results_action', { action: a.getAttribute('data-sm-empty-action') });
      var d = e.target.closest('[data-sm-dym]');
      if (d) track('sm_ymm_did_you_mean_click', { query: query, suggestion: d.textContent });
    });
  })();

  /* ---------- change bike, OEM link clicks (anywhere) ---------- */

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sm-change-bike]')) {
      e.preventDefault();
      if (typeof window.openMotofitYmmSelector === 'function') window.openMotofitYmmSelector();
      else if (window.SmGarage) window.SmGarage.open({ addForm: true });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    var oemLink = e.target.closest('[data-sm-oem-link]');
    if (oemLink) track('sm_ymm_oem_link_click', { href: oemLink.getAttribute('href') });
  });

  /* ---------- 6. popular bikes in Shop by Vehicle ---------- */

  (function () {
    if (!C.popular) return;
    var wrapper = document.getElementById('ymmInlineWrapper');
    if (!wrapper || !wrapper.parentNode) return;
    var chips = String(C.popular).split(/\r?\n/).map(function (line) {
      var p = line.split('|').map(function (x) { return x.trim(); });
      if (p.length < 2 || !p[0] || !/^(\/|https:\/\/)/.test(p[1])) return '';
      return '<a class="sm-yp-chip" href="' + esc(p[1]) + '" data-sm-popular="' + esc(p[0]) + '">' + esc(p[0]) + '</a>';
    }).filter(Boolean);
    if (!chips.length) return;

    var box = document.createElement('div');
    box.className = 'sm-yp-quick';
    box.innerHTML = '<p class="sm-yp-quick__label">Popular bikes</p><div class="sm-yp-quick__chips">' + chips.join('') + '</div>';
    wrapper.parentNode.insertBefore(box, wrapper);

    function sync() {
      var saved = window.SmGarage ? window.SmGarage.list().length : 0;
      box.hidden = saved > 0;
    }
    sync();
    document.addEventListener('smoto:garage:updated', sync);
    box.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sm-popular]');
      if (a) track('sm_ymm_popular_bike_click', { bike: a.getAttribute('data-sm-popular') });
    });
  })();

  /* ---------- 7. tracking: vehicle picked, bike link opened ---------- */

  var lastVehicleKey = '';
  function trackVehicle(source) {
    var v = vehicle();
    if (!v) return;
    var key = v.label.toLowerCase();
    if (key === lastVehicleKey) return;
    lastVehicleKey = key;
    track('sm_ymm_vehicle_selected', { vehicle: v.label, year: v.year, make: v.make, model: v.model, source: source });
  }
  document.addEventListener('motofit:ymm:updated', function () {
    setTimeout(function () { trackVehicle('selector'); }, 200);
  });
  if (ssGet('smoto:bike-link')) {
    ssDel('smoto:bike-link');
    whenVehicle(function (v) {
      if (!v) return;
      lastVehicleKey = v.label.toLowerCase();
      track('sm_ymm_bike_link_opened', { vehicle: v.label });
    });
  } else {
    // remember the bike already active on arrival, so only real changes count as picks
    whenVehicle(function (v) { if (v && !lastVehicleKey) lastVehicleKey = v.label.toLowerCase(); });
  }

  window.SmYmmPlus = {
    openPartsDesk: openPartsDesk,
    track: track,
    refreshYmm: Prune ? Prune.refresh : function () {}
  };
})();
